import axios from "axios";
import keycloak from "../keycloack";
import getEnv from "../config";

const baseURL = getEnv("REACT_APP_API_URL");

const AUTH_ENABLED = getEnv("REACT_APP_AUTH_ENABLED") === "true";

/**
 * Configure Keycloak auth interceptors on an axios instance.
 * Attaches Bearer token to requests and handles 401 refresh + retry.
 */
export function configureAuthInterceptors(instance) {
  if (!AUTH_ENABLED) return;

  instance.interceptors.request.use(
    function (config) {
      if (keycloak?.authenticated && keycloak?.token) {
        config.headers["Authorization"] = "Bearer " + keycloak.token;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  let refreshPromise = null;
  const REFRESH_FAILED = Symbol("REFRESH_FAILED");

  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const originalRequest = error.config;

      if (
        error.response &&
        error.response.status === 401 &&
        originalRequest &&
        !originalRequest._retry &&
        keycloak?.authenticated
      ) {
        originalRequest._retry = true;

        if (!refreshPromise) {
          refreshPromise = keycloak.updateToken(5)
            .catch(function () { return REFRESH_FAILED; })
            .finally(function () { refreshPromise = null; });
        }

        return refreshPromise.then(function (result) {
          if (result === REFRESH_FAILED) {
            keycloak.logout();
            return Promise.reject(error);
          }
          originalRequest.headers["Authorization"] = "Bearer " + keycloak.token;
          return axios(originalRequest);
        });
      }

      return Promise.reject(error);
    }
  );
}

const api = axios.create({ baseURL });
configureAuthInterceptors(api);

export default api;